import { render, staticRenderFns } from "./RadioSelectPopup.vue?vue&type=template&id=5327928a&scoped=true&"
import script from "./RadioSelectPopup.vue?vue&type=script&lang=js&"
export * from "./RadioSelectPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5327928a",
  null
  
)

export default component.exports